export default "{\n    \"defaultLabel\": \"Botón\"\n}"